import utils from '../common/util';

const cmpPlayerNameContainer = {
    component: null,

    init: function (element)
    {
        utils.log('cmpPlayerNameContainer initiated : #' + element.id, 'info');

        const _ = utils.setEnvironment(this);
        _.component = element;
        _.nameContainer = document.getElementById('cmp-game-play__name-container__name');
        _.descriptionContainer = document.getElementById('cmp-game-play__name-container__description');


        utils.setVariables(this);
    },

    hideDescription: function ()
    {
        const _ = this;

        _.component.classList.add('reduced');
        _.descriptionContainer.classList.add('opacity-0');
    },

    showDescription: function ()
    {
        const _ = this;

        _.playerNameContainer.classList.remove('reduced');
        _.descriptionContainer.classList.remove('opacity-0');
    },

    updatePlayerName: function ()
    {
        const _ = this;

        utils.setVariables(_);

        _.nameContainer.textContent = _.opponentPlayer;
        _.showPlayerNameContainer();

    },

    hidePlayerNameContainer: function ()
    {
        const _ = this;

        _.component.classList.add('opacity-0');
    },

	showPlayerNameContainer: function ()
	{
		const _ = this;

		_.component.classList.remove('opacity-0');
		_.showDescription();
	},

	removePlayerNameContainer: function ()
	{
		const _ = this;

		_.component.classList.add('opacity-0');
	},
}

export default cmpPlayerNameContainer;
